<div *ngIf="initializing; else done" class="wait">
  <mat-spinner color="primary" [diameter]="30"></mat-spinner>
</div>

<ng-template #done>
  <div
    *ngFor="let b of day_array"
    class="time-bucket"
    id="{{ cancha.id }}-{{ b }}"
    [ngClass]="{ unavailable: isTimeUnavailable(b) }"
  >
  </div>


  <app-reserva [reserva]="reserva" (reservaModified)="onReservaModified($event)"
    *ngFor="let reserva of reservas"></app-reserva>


</ng-template>